// extracted by mini-css-extract-plugin
export var sIntro = "index-module--sIntro--aRhTq";
export var sIntroDesc = "index-module--sIntroDesc--UKRjY";
export var sIntroSection = "index-module--sIntroSection--25Syc";
export var sProjectElem = "index-module--sProjectElem--UVudP";
export var sProjectElemOverlay = "index-module--sProjectElemOverlay--6a2yL";
export var sProjectGridContainer = "index-module--sProjectGridContainer--pDmbc";
export var sProjectGridSec = "index-module--sProjectGridSec--LRtBl";